import type { components } from "../../generated/api.js";

type TeamMemberDTO = components["schemas"]["TeamMemberDTO"];
type ServiceGroupDTO = components["schemas"]["ServiceGroupDTO"];
type ServiceDTO = components["schemas"]["ServiceDTO"];

/** Wie die Oberfläche den Umfang zeigt: „Keine" ist eine Auswahl ohne Freigabe. */
export type ScopeMode = "ALL" | "SELECTED" | "NONE";

/** Der Umfang, während er bearbeitet wird. */
export interface ScopeDraft {
  mode: ScopeMode;
  groupIds: string[];
  serviceIds: string[];
}

export const ALL_SCOPE: ScopeDraft = { mode: "ALL", groupIds: [], serviceIds: [] };

/** Vom gespeicherten Mitglied zum Entwurf. */
export function draftOf(member: TeamMemberDTO): ScopeDraft {
  if (member.scope === "ALL") {
    return ALL_SCOPE;
  }
  const empty = member.groupIds.length === 0 && member.serviceIds.length === 0;
  return { mode: empty ? "NONE" : "SELECTED", groupIds: member.groupIds, serviceIds: member.serviceIds };
}

/** Vom Entwurf zum Body der API. Eine leere Auswahl ist dasselbe wie „Keine". */
export function scopeBody(draft: ScopeDraft): {
  scope: "ALL" | "SELECTED";
  groupIds: string[];
  serviceIds: string[];
} {
  if (draft.mode === "ALL") {
    return { scope: "ALL", groupIds: [], serviceIds: [] };
  }
  if (draft.mode === "NONE") {
    return { scope: "SELECTED", groupIds: [], serviceIds: [] };
  }
  return { scope: "SELECTED", groupIds: draft.groupIds, serviceIds: draft.serviceIds };
}

/** Kurzfassung für die Liste, etwa „Festival · 2 Angebote". */
export function scopeSummary(
  member: TeamMemberDTO,
  groups: ServiceGroupDTO[],
  services: ServiceDTO[],
): string {
  if (member.scope === "ALL") {
    return "Alle Angebote";
  }
  const names = member.groupIds.map((id) => groups.find((group) => group.id === id)?.name ?? "Gruppe");
  const single = member.serviceIds.length;
  if (names.length === 0 && single === 0) {
    return "Keine Angebote";
  }
  const titles =
    single === 1
      ? [services.find((service) => service.id === member.serviceIds[0])?.title ?? "1 Angebot"]
      : single > 1
        ? [`${single} Angebote`]
        : [];
  return [...names, ...titles].join(" · ");
}
